// Get all trades
export const GET_TRADES_BASED_ON_BUILDING_REQUEST = "GET_TRADES_BASED_ON_BUILDING_REQUEST";
export const GET_TRADES_BASED_ON_BUILDING_SUCCESS = "GET_TRADES_BASED_ON_BUILDING_SUCCESS";
export const GET_TRADES_BASED_ON_BUILDING_FAILURE = "GET_TRADES_BASED_ON_BUILDING_FAILURE";

// Add trade
export const ADD_TRADE_REQUEST = "ADD_TRADE_REQUEST";
export const ADD_TRADE_SUCCESS = "ADD_TRADE_SUCCESS";
export const ADD_TRADE_FAILURE = "ADD_TRADE_FAILURE";

// Update trade
export const UPDATE_TRADE_REQUEST = "UPDATE_TRADE_REQUEST";
export const UPDATE_TRADE_SUCCESS = "UPDATE_TRADE_SUCCESS";
export const UPDATE_TRADE_FAILURE = "UPDATE_TRADE_FAILURE";

// Delete trade
export const DELETE_TRADE_REQUEST = "DELETE_TRADE_REQUEST";
export const DELETE_TRADE_SUCCESS = "DELETE_TRADE_SUCCESS";
export const DELETE_TRADE_FAILURE = "DELETE_TRADE_FAILURE";

// Get Trade by Id
export const GET_TRADE_BY_ID_REQUEST = "GET_TRADE_BY_ID_REQUEST";
export const GET_TRADE_BY_ID_SUCCESS = "GET_TRADE_BY_ID_SUCCESS";
export const GET_TRADE_BY_ID_FAILURE = "GET_TRADE_BY_ID_FAILURE";

// Update Trade Entity Param
export const UPDATE_TRADE_ENTITY_PARAMS_SUCCESS = "UPDATE_TRADE_ENTITY_PARAMS_SUCCESS";
export const UPDATE_TRADE_ENTITY_PARAMS_FAILURE = "UPDATE_TRADE_ENTITY_PARAMS_FAILURE";

export const GET_LIST_FOR_COMMON_FILTER_REQUEST = "GET_LIST_FOR_COMMON_FILTER_REQUEST";
export const GET_LIST_FOR_COMMON_FILTER_SUCCESS = "GET_LIST_FOR_COMMON_FILTER_SUCCESS";
export const GET_LIST_FOR_COMMON_FILTER_FAILURE = "GET_LIST_FOR_COMMON_FILTER_FAILURE";

export const GET_ALL_TRADE_LOG_REQUEST = "GET_ALL_TRADE_LOG_REQUEST";
export const GET_ALL_TRADE_LOG_SUCCESS = "GET_ALL_TRADE_LOG_SUCCESS";
export const GET_ALL_TRADE_LOG_FAILURE = "GET_ALL_TRADE_LOG_FAILURE";

export const RESTORE_TRADE_LOG_REQUEST = "RESTORE_TRADE_LOG_REQUEST";
export const RESTORE_TRADE_LOG_SUCCESS = "RESTORE_TRADE_LOG_SUCCESS";
export const RESTORE_TRADE_LOG_FAILURE = "RESTORE_TRADE_LOG_FAILURE";

export const DELETE_TRADE_LOG_REQUEST = "DELETE_TRADE_LOG_REQUEST";
export const DELETE_TRADE_LOG_SUCCESS = "DELETE_TRADE_LOG_SUCCESS";
export const DELETE_TRADE_LOG_FAILURE = "DELETE_TRADE_LOG_FAILURE";

export const GET_TRADE_EXPORT_REQUEST = "GET_TRADE_EXPORT_REQUEST";
export const GET_TRADE_EXPORT_SUCCESS = "GET_TRADE_EXPORT_SUCCESS";
export const GET_TRADE_EXPORT_FAILURE = "GET_TRADE_EXPORT_FAILURE";

export const GET_ALL_CLIENT_USERS_REQUEST = "GET_ALL_CLIENT_USERS_REQUEST";
export const GET_ALL_CLIENT_USERS_SUCCESS = "GET_ALL_CLIENT_USERS_SUCCESS";
export const GET_ALL_CLIENT_USERS_FAILURE = "GET_ALL_CLIENT_USERS_FAILURE";

// Get all consultancy users
export const GET_ALL_CONSULTANCY_USERS_REQUEST = "GET_ALL_CONSULTANCY_USERS_REQUEST";
export const GET_ALL_CONSULTANCY_USERS_SUCCESS = "GET_ALL_CONSULTANCY_USERS_SUCCESS";
export const GET_ALL_CONSULTANCY_USERS_FAILURE = "GET_ALL_CONSULTANCY_USERS_FAILURE";

export const GET_ALL_CONSULTANCIES_DROPDOWN_REQUEST = "GET_ALL_CONSULTANCIES_DROPDOWN_REQUEST";
export const GET_ALL_CONSULTANCIES_DROPDOWN_SUCCESS = "GET_ALL_CONSULTANCIES_DROPDOWN_SUCCESS";
export const GET_ALL_CONSULTANCIES_DROPDOWN_FAILURE = "GET_ALL_CONSULTANCIES_DROPDOWN_FAILURE";

// Get all Clients
export const GET_ALL_CLIENTS_REQUEST = "GET_ALL_CLIENTS_REQUEST";
export const GET_ALL_CLIENTS_SUCCESS = "GET_ALL_CLIENTS_SUCCESS";
export const GET_ALL_CLIENTS_FAILURE = "GET_ALL_CLIENTS_FAILURE";

export const GET_ALL_BUILDINGS_DROP_DOWN_REQUEST = "GET_ALL_BUILDINGS_DROP_DOWN_REQUEST";
export const GET_ALL_BUILDINGS_DROP_DOWN_SUCCESS = "GET_ALL_BUILDINGS_DROP_DOWN_SUCCESS";
export const GET_ALL_BUILDINGS_DROP_DOWN_FAILURE = "GET_ALL_BUILDINGS_DROP_DOWN_FAILURE";
